var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 4.99999H18.3337V6.66666H16.667V17.5C16.667 17.721 16.5792 17.933 16.4229 18.0892C16.2666 18.2455 16.0547 18.3333 15.8337 18.3333H4.16699C3.94598 18.3333 3.73402 18.2455 3.57774 18.0892C3.42146 17.933 3.33366 17.721 3.33366 17.5V6.66666H1.66699V4.99999H5.83366V2.49999C5.83366 2.27898 5.92146 2.06701 6.07774 1.91073C6.23402 1.75445 6.44598 1.66666 6.66699 1.66666H13.3337C13.5547 1.66666 13.7666 1.75445 13.9229 1.91073C14.0792 2.06701 14.167 2.27898 14.167 2.49999V4.99999ZM15.0003 6.66666H5.00033V16.6667H15.0003V6.66666ZM7.50033 9.16666H9.16699V14.1667H7.50033V9.16666ZM10.8337 9.16666H12.5003V14.1667H10.8337V9.16666ZM7.50033 3.33332V4.99999H12.5003V3.33332H7.50033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.a0cdd80ca27f4caf5099ad6135483c09.svg";
export { ForwardRef as ReactComponent };